import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class DestroyedConcreteBlock extends PhysicalThing {
	static key = "DestroyedConcreteBlock";
	constructor(xy: XY) {
		super(xy, false);
	}

	getZOrder(): number {
		return ZOrder.CARPET_LIKE;
	}

	static deserialize(data: any): DestroyedConcreteBlock {
		const d = new DestroyedConcreteBlock(deserializeXY(data.xy));
		d.visualId = data.visualId;
		return d;
	}
}
